export default "* Raslepind\n* Valnød\n* Musikinstrument";